import AppView from '@common/components/app-view';
import BotListContent from './components/BotListContent';

export default function BotListView() {
    return (
        <AppView title="Chatbots" activeExtensionView="bots" showHeader={false}>
            <BotListContent />
        </AppView>
    );
} 